import ArticleComment from './ArticleComment';

export default ArticleComment;
